import { ActionType } from 'typesafe-actions';
import { User } from '../auth';
import { BidPackageLineItem } from '../bid-packages';
import { Bidder } from '../bidders';
import { Contract } from '../contracts';
import * as actions from './actions';
import { AxiosError } from 'axios';

export type BidChancesAction = ActionType<typeof actions>;

export interface BidChancesState {
  bidChances: {
    data: BidChance[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  bidChance: {
    data: BidChance | null;
    loading: boolean;
    error: AxiosError | null;
  };
}

export enum BidChanceStatus {
  INVITED = '0',
  ACCEPTED = '1',
  DECLINED = '2',
  SUBMITTED = '3',
  WON = '4',
  LOST = '5',
  RECONFIRM = '6',
}

export const bidChanceStatusKorean = {
  '0': '검토중',
  '1': '참가 수락',
  '2': '참가 거절',
  '3': '제출완료',
  '4': '선정',
  '5': '미선정',
  '6': '재요청',
} as const;

export interface BidChance {
  id: number;
  enterpriseId: string;
  status: BidChanceStatus;
  bidder: Bidder;
  bidProposals: any[];
  bidChanceHistories: BidChanceHistory[];
}

export interface BidChanceLineItem {
  id: number;
  code: string;
  editable: boolean;
  review: boolean;
  currentRate: number;
  contract: Partial<Contract>;
  bidChance: Partial<BidChance>;
}

export interface BidProposalLineItem {
  id: number;
  bidProposal?: BidProposal;
  quantity?: number;
  bidPackageLineItem: BidPackageLineItem;
}

export interface BidChanceParams {
  enterpriseId?: string;
  bidChanceId?: string;
  bidChance?: BidChance;
  bidProposalLineItems?: any[];
  amount?: number;
  bidProposalId?: string;
  file?: any;
  bidPackageId?: string;
  d1?: any;
  d2?: any;
  bmt?: any;
  input?: any;
}

export interface BidProposal {
  id: number;
  bidChance: BidChance;
  amount: number;
  bidProposalLineItems: any[];
  file: any[];
  metaData: any;

  /*
  // 간접노무비 요율
  costAccountingSheetRate0: number;

  // 산재보험료 요율
  costAccountingSheetRate1: number;

  // 고용보험료 요율
  costAccountingSheetRate2: number;

  // 국민건강보험료 요율
  costAccountingSheetRate3: number;

  // 국민연금보험료 요율
  costAccountingSheetRate4: number;

  // 노인장기요양보험료 요율
  costAccountingSheetRate5: number;

  // 퇴직공제부금비 요율
  costAccountingSheetRate6: number;

  // 산업안전보건관리비 요율
  costAccountingSheetRate7: number;

  // 기타 경비 요율
  costAccountingSheetRate8: number;

  // 환경보전비 요율
  costAccountingSheetRate9: number;

  // 건설하도급대금지급보증서발급수수료 요율
  costAccountingSheetRate10: number;

  // 건설기계대여금지급보증서발급수수료 요율
  costAccountingSheetRate11: number;

  // 일반관리비 요율
  costAccountingSheetRate12: number;

  // 이윤 요율
  costAccountingSheetRate13: number;

  // 부가가치세 요율
  costAccountingSheetRate14: number;

  // 매입세 요율
  costAccountingSheetRate15: number;
  */
}

export interface BidProposalParams {
  enterpriseId?: string;
  bidChanceId?: string;
  bidProposal?: BidProposal;
}

export interface BidChanceHistory {
  id: number;
  user: User;
  userData?: any;
  description: string;
  createdAt: string;
}
